module.exports = "<button type=\"submit\" class=\"btn btn-primary\" id=\"create-btn\" ng-disabled=\"disabled\" translate>\r\n    Create\r\n</button>";